import Layout from "../components/Layout";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import { createSearchParams, useNavigate } from "react-router-dom";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "react-multi-select-component";

const EmployeeIDPAdmin = () => {
    const [start] = useState(0);
    const [empIdpList, setEmpIdpList] = useState([]);
    const { user } = useSelector((state) => state["auth"]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const navigate = useNavigate()

    const [factoryData, setFactoryData] = useState([])
    const [departmentData, setDepartmentData] = useState([])
    const [designationData, setDesignationData] = useState([])
    const [quarterNames, setQuarterNames] = useState([]);
    const [monthNames, setMonthNames] = useState([]);
    const [selected, setSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [getFilterData, setGetFilterData] = useState([]);


    useEffect(() => {
        initFilters();
        getEmployeeIDPList(user.registerID)
        GetEmployeeFilterData()
        GetAllMonthList();
        GetSubmittedQuarterNames(user.registerID);
    }, [])



    const GetEmployeeFilterData = () => {
        axios.get(BASE_URL + "/api/report/GetFilterFactoryData")
            .then(response => {
                setFactoryData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDepartmentData")
            .then(response => {
                setDepartmentData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDesignationData")
            .then(response => {
                //console.log(response.data);
                setDesignationData(response.data)
            })
            .catch(console.error)
    }

    const GetSubmittedQuarterNames = (id) => {
        axios
            .post(BASE_URL + `/api/dashboard/GetSubmittedQuarterNames/${id}`)
            .then((response) => {
                setQuarterNames(
                    response.data.map((record) => {
                        return {
                            value: record.quarterID,
                            label: record.quarterName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetAllMonthList = () => {
        axios.post(BASE_URL + `/api/utility/GetAllMonth`)
            .then((response) => {
                console.log(response);
                setMonthNames(
                    response.data.map((record) => {
                        return {
                            value: record.monthID,
                            label: record.monthName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    const getEmployeeIDPList = (id) => {
        axios.get(BASE_URL + "/api/idp/GetIDPEmployeeListAdmin/" + id)
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }

    const getEmployeeIDPListBySearch = (id) => {
        axios.get(BASE_URL + "/api/idp/GetIDPEmployeeListAdmin/" + id)
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }


    const _actionBody = (empIdp) => (<>
        <button type="button" style={{ cursor: "pointer", padding: "2px 5px 2px 5px", fontSize: "10pt" }} className="btn btn-outline-primary" onClick={() => {
            navigate({
                pathname: "/IDPDetails",
                search: createSearchParams({
                    employeeId: empIdp.registerID
                }).toString()
            });
        }}>Create IDP</button>
    </>)
    const _actionIDPBody = (empIdp) => (<>
        {console.log(btoa("category=textile&user=user1"))}
        {console.log(empIdp)}
        <div class="btn-group">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Select
            </button>
            <ul class="dropdown-menu" style={{ minWidth: "11rem" }}>
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={() => {
                        console.log("Hello");
                        console.log(empIdp);
                        var selectedQuarters = selected.map(o => o.value)
                        //window.open("http://localhost:13805/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));    
                        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));                        
                        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterIDList=" + selectedQuarters.toString()));                        
                        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr=" + btoa("RegisterID=" + empIdp.registerID + "&QuarterIDList=" + empIdp.quarterID.toString()));
                        //window.open("http://localhost:13805/PMSReport/IndividualPerformanceReport?SearchStr=" + btoa("RegisterID=" + empIdp.registerID + "&QuarterIDList=" + empIdp.quarterID.toString()));
                    }}><i class="bi bi-person-bounding-box"></i> IDP Report</a>
                </li>
                {/* <li><a style={{fontWeight:"600"}} className="dropdown-item" href="#" 
                onClick={()=>{
                    navigate({
                        pathname: "/IDPDetails",
                        search: createSearchParams({
                            employeeId: btoa(empIdp.registerID)
                        }).toString()
                    });
                    }}><i class="bi bi-pencil-fill"></i> Create IDP</a>
                </li> */}
                <li><a style={{ fontWeight: "600" }} className="dropdown-item" href="#"
                    onClick={() => {
                        navigate({
                            pathname: "/EvaluationReport",
                            search: createSearchParams({
                                employeeId: btoa(empIdp.registerID)
                            }).toString()
                        });
                    }}><i class="bi bi-person-lines-fill"></i> Evaluation Report</a>
                </li>
            </ul>
        </div>
    </>)
    const _actionReportBody = (empIdp) => (<>
        <button type="button" style={{ cursor: "pointer", padding: "2px 5px 2px 5px", fontSize: "10pt" }} className="btn btn-outline-secondary" onClick={() => {
            navigate({
                pathname: "/EvaluationReport",
                search: createSearchParams({
                    employeeId: empIdp.registerID
                }).toString()
            });
        }}>Evaluation Report</button>
    </>)

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }


    const initFilters = () => {
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
        });
        setGlobalFilterValue('');
    }
    const clearFilter = () => {
        initFilters();
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter} />
                    <span className="p-input-icon-left"> <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                            placeholder="Keyword Search" />
                    </span>
                </div>
            </div>
        </div>
    );


    return (<Layout>

        <div className="card mt-2">

            {/* <h6><i class="bi bi-person-check"></i> Employee List</h6> */}

            <div className="card-header">
                <div className="row">
                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_factory">
                            <option value="">Factory</option>
                            {factoryData.map((value, index) => {
                                return <option key={index} value={value.factoryName}>{value.factoryName}</option>
                            })}

                        </select>
                    </div>
                    <div className="col-md-3">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_dept">
                            <option value="">Department</option>
                            {departmentData.map((value, index) => {
                                return <option key={index} value={value.department}>{value.department}</option>
                            })}
                        </select>
                    </div>



                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_designation">
                            <option value="">Designation</option>
                            {designationData.map((value, index) => {
                                return <option key={index} value={value.designation}>{value.designation}</option>
                            })}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_Month">
                            <option value="">Month</option>
                            {monthNames.map((value, index) => {
                                return <option key={index} value={value.value}>{value.label}</option>
                            })}

                        </select>
                    </div>



                    <div className="col-md-3">
                        <MultiSelect
                            options={quarterNames}
                            value={selected}
                            onChange={setSelected}
                            labelledBy="Quarter"
                            id="ddlMultiQuarter"
                            size="lg"
                        />
                    </div>




                    <div className="col-md-2">
                        <button className="btn btn-primary btn-sm" onClick={() => {
                            setIsLoading(true);



                            var selectedQuarters = selected.map(o => o.value)
                            //console.log(selectedQuarters);


                            const factory = document.getElementById("emp_factory").value
                            const emp_dept = document.getElementById("emp_dept").value
                            const emp_designation = document.getElementById("emp_designation").value
                            const joiningMonth = document.getElementById("emp_Month").value === "" ? "-1" : document.getElementById("emp_Month").value;
                            const _QuarterID = selectedQuarters;



                            const data = {
                                FactoryName: factory,
                                Department: emp_dept,
                                Designation: emp_designation,
                                JoiningMonthID: joiningMonth,
                                QuarterIDList: selectedQuarters.toString()
                            }
                            console.log(data)
                            axios.post(BASE_URL + "/api/idp/GetIDPEmployeeListAdminBySearch", JSON.stringify(data))
                                .then(response => {
                                    //setGetFilterData(response.data)
                                    console.log(response.data);
                                    setEmpIdpList(response.data)
                                    setIsLoading(false);
                                })
                                .catch(function (error) {
                                    setIsLoading(false);
                                    console.log(error);
                                });
                        }}><i class="bi bi-funnel"></i> Filter
                        </button>
                        <button className="btn ms-2 text-white btn-info btn-sm"><i class="bi bi-eraser"></i> Clear</button>
                    </div>



                </div>



            </div>
            <div className="card-body">
                <DataTable value={empIdpList} header={header} paginator rows={7} first={start}
                    globalFilterFields={['quarterName', 'employeeCode', 'employeeName', 'department', 'designation']}
                    filters={filters}
                    dataKey="registerID"
                    paginatorTemplate=" PageLinks  ">
                    <Column field="registerID" header="registerID" hidden={true} />
                    <Column field='quarterName' style={{ width: "13%" }} sortable alignHeader="center" header="Quarter Name" />
                    <Column field='employeeCode' style={{ width: "13%" }} sortable alignHeader="center" header="Emp Code" />
                    <Column field='employeeName' sortable alignHeader="center" header="Employee Name" />
                    <Column field='department' sortable alignHeader="center" header="Department" />
                    <Column field='designation' sortable alignHeader="center" header="Designation" />
                    <Column field="registerID" style={{ width: "10%" }} align="center" alignHeader="center" header="Action" body={_actionIDPBody} />
                    {/* <Column field="registerID" style={{width:"120px"}} align="center" alignHeader="center" header="Action" body={_actionBody}/>
                    <Column field="registerID" style={{width:"150px"}} align="center" alignHeader="center" header="Action" body={_actionReportBody}/> */}
                </DataTable>
            </div>
        </div>

    </Layout>)
}


export default EmployeeIDPAdmin